import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import {reduxForm, Field, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import {changeOutlet, changeDate, showModalOutletMobile, setFlagAsyncDashboard} from 'actions/dashboard'
import styles from './ActionBar.css'
import OutletModal from 'components/Fields/ReduxForm/OutletModal'
import * as mpDashboard from 'mixpanel/dashboard'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    const {outlets, showModalOutletMobileState} = this.props
    return (
      <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
        <MenuTitle menuTitle='Dashboard' column='12' />
        <form className='form-inline' onSubmit={this._onSubmit}>
          <div className={!isFullSiteMode() ? `form-group ${styles['form-group']}` : `form-group ${styles['form-full-site']}`}>
            <div className='visible-md visible-lg'>
              <Field
                component={DropdownOutlet}
                name='outlet'
                outlets={outlets || []}
                onChangeOutletIds={this._onChangeOutlet}
                allOutletOption
              />
            </div>
          </div>
          <div className={!isFullSiteMode() ? `form-group ${styles['form-group']}` : `form-group ${styles['form-full-site']}`}>
            <Field
              component={DropdownCalendar}
              name='date'
              onChange={this._onChangeDate}
              updateServerOnChange
            />
          </div>
        </form>
        <Field
          component={OutletModal}
          name='outlet'
          outlets={outlets || []}
          onChangeOutletIds={this._onChangeOutlet}
          allOutletOption
          show={showModalOutletMobileState}
        />
      </div>
    )
  }

  _onHideOutletModal = () => {
    this.props.dispatch(showModalOutletMobile(false))
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {outlet} = this.props.search
    mpDashboard.dashboardChangeFilter({
      outletIds: outlet,
      startDate,
      endDate
    })
    this.props.dispatch(setFlagAsyncDashboard(false))
    this.props.dispatch(changeDate(startDate, endDate, outlet))
  };

  _onChangeOutlet = (outletIds = []) => {
    const {startDate, endDate} = this.props.search.date
    mpDashboard.dashboardChangeFilter({
      outletIds, startDate, endDate
    })
    this.props.dispatch(setFlagAsyncDashboard(false))
    this.props.dispatch(changeOutlet(outletIds, startDate, endDate))
  };

  _onSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    outlets: state.dashboard.index.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile,
    user: state.moka.user,
    subscriptionExpired: state.subscriptionExpired
  }
}

const mapForm = {
  form: 'search'
}

export default reduxForm(mapForm)(connect(mapStateToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Dashboard/ActionBar/ActionBar.js